module.exports = __webpack_public_path__ + "img/DescriptionOutlined.f27b2875.svg";